import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function MandatoEditor() {
  const [open, setOpen] = useState(false);
  const [exp, setExp] = useState('');
  const [venc, setVenc] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    if (!open) return;
    axios.get(`${API}/api/mandato`).then((r) => {
      setExp(r.data.fecha_expedicion || '2025-05-15');
      setVenc(r.data.fecha_vencimiento || '2026-05-15');
    });
  }, [open]);

  const save = async () => {
    setSaving(true);
    setMsg(null);
    try {
      await axios.put(`${API}/api/mandato`, {
        fecha_expedicion: exp,
        fecha_vencimiento: venc,
      });
      setMsg({ ok: true, text: 'Fechas del mandato actualizadas.' });
      setTimeout(() => setOpen(false), 800);
    } catch (e) {
      setMsg({ ok: false, text: e.response?.data?.error || e.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-xs px-3 py-1.5 rounded-lg border border-gold-400 text-gold-700 hover:bg-gold-50"
      >
        Actualizar mandato
      </button>

      {open && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-xl border border-gray-200 w-full max-w-md p-6">
            <h3 className="text-lg font-bold text-gold-700 mb-4">Fechas del Mandato</h3>
            <p className="text-xs text-gray-500 mb-4">
              Defina el rango de fechas del mandato (desde – hasta) que se usará para validar el campo "Doc. Soporte - Mandato" contra la SAE.
            </p>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Desde (Fecha de expedición)</label>
            <input
              type="date"
              value={exp}
              onChange={(e) => setExp(e.target.value)}
              className="w-full mb-4 border border-gray-300 rounded-lg px-3 py-2 text-sm"
            />
            <label className="block text-sm font-semibold text-gray-700 mb-1">Hasta (Fecha de vencimiento)</label>
            <input
              type="date"
              value={venc}
              onChange={(e) => setVenc(e.target.value)}
              className="w-full mb-4 border border-gray-300 rounded-lg px-3 py-2 text-sm"
            />
            {msg && (
              <p className={`text-xs mb-3 ${msg.ok ? 'text-green-700' : 'text-red-700'}`}>{msg.text}</p>
            )}
            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-lg text-sm border border-gray-300 hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={save}
                disabled={saving}
                className="px-3 py-2 rounded-lg text-sm bg-gold-600 text-white hover:bg-gold-700 disabled:bg-gray-300"
              >
                {saving ? 'Guardando…' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
